import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { forkJoin, from, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { environment } from 'src/environments/environment';

export interface ClientRequestHeaders {
  clientIpAddress: string;
  deviceId: string;
}

@Injectable({
  providedIn: 'root',
})
export class FingerPrintService {

  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);

  getClientRequestHeaders(): Observable<ClientRequestHeaders> {
    if (!isPlatformBrowser(this.platformId)) {
      return of({ clientIpAddress: '', deviceId: '' });
    }

    return forkJoin({
      clientIpAddress: this.getPublicIp(),
      deviceId: this.getDeviceId()
    });
  }

  private getPublicIp(): Observable<string> {
    return this.http.get<{ ip: string }>(environment.urlIpify).pipe(
      map(response => response.ip),
      catchError(error => {
        console.error('Error obteniendo IP pública', error);
        return of('');
      })
    );
  }

  private getDeviceId(): Observable<string> {
    return from(FingerprintJS.load()).pipe(
      switchMap(fp => from(fp.get())),
      map(result => result.visitorId),
      catchError(error => {
        console.error('Error generando device-id', error);
        return of('');
      })
    );
  }

}
